/**
 * @generated SignedSource<<d90456275f5152a3138133dc72b9ce82>>
 * @relayHash 43c09e5a9bda56fe2b1d2864d18f480d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 1b5e3e9297ce0fddcf00c975ec575ac0d34450917c7d1a6fa7fc92fdcf4b50c1

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type navLinksQuery$variables = {
  cloudId: string;
  hubAri: string;
  isConfigurableSiteTreeEnabled: boolean;
  isDraft?: boolean | null;
};
export type navLinksQuery$data = {
  readonly helpCenter: {
    readonly helpCenterById: {
      readonly __typename: "HelpCenter";
      readonly " $fragmentSpreads": FragmentRefs<"moreDropdown_AtlassianHubAppShell" | "portalDropdown_AtlassianHubAppShell" | "siteNavigation_AtlassianHubAppShell">;
    } | {
      // This will never be '%other', but we need some
      // value in case none of the concrete values match.
      readonly __typename: "%other";
    } | null;
  } | null;
};
export type navLinksQuery = {
  response: navLinksQuery$data;
  variables: navLinksQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "hubAri"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isConfigurableSiteTreeEnabled"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isDraft"
},
v4 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  }
],
v5 = [
  {
    "kind": "Variable",
    "name": "helpCenterAri",
    "variableName": "hubAri"
  },
  {
    "kind": "Variable",
    "name": "isDraft",
    "variableName": "isDraft"
  }
],
v6 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v7 = {
  "kind": "ScalarField",
  "name": "id"
},
v8 = [
  {
    "kind": "ScalarField",
    "name": "default"
  }
],
v9 = [
  (v7/*: any*/),
  {
    "concreteType": "HelpCenterPageName",
    "kind": "LinkedField",
    "name": "name",
    "plural": false,
    "selections": (v8/*: any*/)
  }
],
v10 = {
  "kind": "InlineFragment",
  "selections": (v9/*: any*/),
  "type": "HelpCenterPage"
},
v11 = {
  "kind": "InlineFragment",
  "selections": [
    (v7/*: any*/)
  ],
  "type": "Node",
  "abstractKey": "__isNode"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "name": "navLinksQuery",
    "selections": [
      {
        "args": (v4/*: any*/),
        "concreteType": "HelpCenterQueryApi",
        "kind": "LinkedField",
        "name": "helpCenter",
        "plural": false,
        "selections": [
          {
            "args": (v5/*: any*/),
            "kind": "LinkedField",
            "name": "helpCenterById",
            "plural": false,
            "selections": [
              (v6/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "kind": "FragmentSpread",
                    "name": "portalDropdown_AtlassianHubAppShell"
                  },
                  {
                    "kind": "FragmentSpread",
                    "name": "moreDropdown_AtlassianHubAppShell"
                  },
                  {
                    "condition": "isConfigurableSiteTreeEnabled",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      {
                        "kind": "FragmentSpread",
                        "name": "siteNavigation_AtlassianHubAppShell"
                      }
                    ]
                  }
                ],
                "type": "HelpCenter"
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v3/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "navLinksQuery",
    "selections": [
      {
        "args": (v4/*: any*/),
        "concreteType": "HelpCenterQueryApi",
        "kind": "LinkedField",
        "name": "helpCenter",
        "plural": false,
        "selections": [
          {
            "args": (v5/*: any*/),
            "kind": "LinkedField",
            "name": "helpCenterById",
            "plural": false,
            "selections": [
              (v6/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "concreteType": "HelpCenterPortals",
                    "kind": "LinkedField",
                    "name": "portals",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "HelpCenterPortal",
                        "kind": "LinkedField",
                        "name": "portalsList",
                        "plural": true,
                        "selections": [
                          (v7/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "name"
                          }
                        ]
                      }
                    ]
                  },
                  {
                    "alias": "customPages",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "filter",
                        "value": {
                          "ids": [],
                          "type": "CUSTOM"
                        }
                      }
                    ],
                    "concreteType": "HelpCenterPage",
                    "kind": "LinkedField",
                    "name": "pages",
                    "plural": true,
                    "selections": (v9/*: any*/),
                    "storageKey": "pages(filter:{\"ids\":[],\"type\":\"CUSTOM\"})"
                  },
                  {
                    "condition": "isConfigurableSiteTreeEnabled",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      {
                        "concreteType": "HelpCenterSiteTree",
                        "kind": "LinkedField",
                        "name": "siteTree",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "HelpCenterFolder",
                            "kind": "LinkedField",
                            "name": "root",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "HelpCenterSiteTreeNodeConnection",
                                "kind": "LinkedField",
                                "name": "contents",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "LinkedField",
                                    "name": "nodes",
                                    "plural": true,
                                    "selections": [
                                      (v6/*: any*/),
                                      (v10/*: any*/),
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v7/*: any*/),
                                          {
                                            "concreteType": "HelpCenterFolderName",
                                            "kind": "LinkedField",
                                            "name": "name",
                                            "plural": false,
                                            "selections": (v8/*: any*/)
                                          },
                                          {
                                            "concreteType": "HelpCenterSiteTreeNodeConnection",
                                            "kind": "LinkedField",
                                            "name": "contents",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "kind": "LinkedField",
                                                "name": "nodes",
                                                "plural": true,
                                                "selections": [
                                                  (v6/*: any*/),
                                                  (v10/*: any*/),
                                                  (v11/*: any*/)
                                                ]
                                              }
                                            ]
                                          }
                                        ],
                                        "type": "HelpCenterFolder"
                                      },
                                      (v11/*: any*/)
                                    ]
                                  }
                                ]
                              },
                              (v7/*: any*/)
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ],
                "type": "HelpCenter"
              },
              (v11/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "1b5e3e9297ce0fddcf00c975ec575ac0d34450917c7d1a6fa7fc92fdcf4b50c1",
    "metadata": {},
    "name": "navLinksQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "0097266245e97d0213b7e8b1bb1bb7a4";

export default node;
